import React from "react";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
//Icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

const GeneralError = ({ errorText, linkText = "Go back to Home", link = "/" }) => {
  return (
    <div className="flex flex-col justify-center items-center h-[calc(100vh-5rem)] px-4 md:px[4rem] text-center">
      <Typography variant="h2" className="text-mainGreen font-semibold">
        Uh oh.
      </Typography>
      <Typography variant="h6">{errorText}</Typography>
      <Link to={link} className="flex items-center mt-4">
        <FontAwesomeIcon icon={faChevronLeft} style={{ marginRight: "5px" }} />
        <Typography variant="h6" className="text-mainGreen">
          {linkText}
        </Typography>
      </Link>
    </div>
  );
};

export default GeneralError;
